/*
 * @Author:
 * @Date: 2025-04-09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-11 14:27:48
 * @FilePath: /src/api/pay.ts
 * @Description: 支付相关API
 */
import { httpRequest } from '@/utils/axios';

/**
 * 获取允许的支付方式
 */
export const getAllowPayment = () => httpRequest('GET:/api/order/payment_type');

// PayPal 相关API
export const getPaypalOrderToken = (data: any) => httpRequest('POST:/api/paypal/pay', { data });
export const paypalPayAction = (data: any) => httpRequest('POST:/api/paypal/deduction', { data });
export const diffPaypalOrderToken = (data: any) =>
  httpRequest('POST:/api/public/difference_pay_pal_pay', { data }, { success: false, fail: true });
export const diffPaypalPayAction = (data: any) =>
  httpRequest(
    'POST:/api/public/difference_pay_pal_deduction',
    { data },
    { success: false, fail: true },
  );
export const getPaypalPlans = () =>
  httpRequest('GET:/api/paypal/get_plans' as any, undefined, { success: false, fail: true });
export const bindPaypalSubscription = (data: any) =>
  httpRequest(
    'POST:/api/paypal/customer_bind_subscription' as any,
    { data },
    { success: false, fail: true },
  );
export const cancelPaypalSubscription = (data: any) =>
  httpRequest(
    'POST:/api/paypal/customer_cancel_subscription' as any,
    { data },
    { success: false, fail: true },
  );
export const getPaypalSubscription = (data: any) =>
  httpRequest('GET:/api/paypal/get_subscription' as any, { data }, { success: false, fail: true });

// PayPal HK 相关API
export const getPaypalHKOrderToken = (data: any) =>
  httpRequest('POST:/api/paypal_hk/pay', { data });
export const paypalHKPayAction = (data: any) =>
  httpRequest('POST:/api/paypal_hk/deduction', { data });
export const diffPaypalHKOrderToken = (data: any) =>
  httpRequest(
    'POST:/api/public/difference_pay_pal_hk_pay',
    { data },
    { success: false, fail: true },
  );
export const diffPaypalHKPayAction = (data: any) =>
  httpRequest(
    'POST:/api/public/difference_pay_pal_hk_deduction',
    { data },
    { success: false, fail: true },
  );
export const getPaypalHKPlans = () => httpRequest('GET:/api/paypal_hk/get_plans');
export const bindPaypalHKSubscription = (data: any) =>
  httpRequest('POST:/api/paypal_hk/customer_bind_subscription', { data });
export const cancelPaypalHKSubscription = (data: any) =>
  httpRequest('POST:/api/paypal_hk/customer_cancel_subscription', { data });
export const getPaypalHKSubscription = (params: {
  customer_id: string;
  payment_merchant: string;
  subscription_id: string;
}) => httpRequest('GET:/api/paypal_hk/get_subscription', { params });

// Adyen 相关API
export const getAdyenPaymentMethods = (data: any) =>
  httpRequest('POST:/api/adyen/get_payment_methods', { data });
export const getAdyenVipPaymentMethods = (data: any) =>
  httpRequest('POST:/api/adyen/vip_get_payment_methods', { data });
// 补差价获取支付方法
export const getAdyenDiffPaymentMethods = (data: any) =>
  httpRequest('POST:/api/public/difference_get_payment_methods', { data });
export const adyenPay = (data: any) => httpRequest('POST:/api/adyen/credit_card_pay', { data });
export const vipAdyenPay = (data: any) =>
  httpRequest('POST:/api/adyen/vip_credit_card_pay', { data });
export const diffAdyenPay = (data: any) =>
  httpRequest('POST:/api/public/difference_adyen_pay', { data });
export const adyenKlarnaSession = (data: any) =>
  httpRequest('POST:/api/adyen/klarna_session', { data });
export const applyAppleSession = (data: any) =>
  httpRequest('POST:/api/adyen/get_payment_session', { data });

// Afterpay 相关API
export const getAfterpayUrl = (data: any) => httpRequest('POST:/api/adyen/after_pay', { data });
export const afterpayPayDetail = (data: any) => httpRequest('POST:/api/adyen/pay_detail', { data });

// Google Pay 相关API
export const getGooglePaymentMethods = (data: any) =>
  httpRequest('POST:/api/adyen/is_show_pays' as any, { data }, { success: false, fail: false });

// Apple Pay 相关API
export const getApplePaymentMethods = (data: any) =>
  httpRequest('POST:/api/adyen/is_show_pays' as any, { data });

// Klarna 相关API
export const createKlarnaSession = (data: any) =>
  httpRequest('POST:/api/klarna/create_session', { data });
export const klarnaPay = (data: any) => httpRequest('POST:/api/klarna/pay', { data });

// UseePay 相关API
export const getUseepayToken = (data: any) =>
  httpRequest('POST:/api/useepay/credit_card_pay', { data });
export const useepayPayDetail = () => httpRequest('POST:/api/useepay/pay_detail', undefined);

// 支付路由相关API
export const paymentRouting = (data: any) => httpRequest('POST:/api/payment/routing', { data });

// 支付中台相关API
export const getPayCenterMethodsList = (data?: any) =>
  httpRequest('GET:/api/pay_center/payment_methods' as any, { data });
export const payCenterPayDetail = (data: any) =>
  httpRequest('POST:/api/pay_center/pay/detail', { data });

// 获取订单可用优惠券列表
export const getOrderCoupon = (data: any) =>
  httpRequest('GET:/api/order/coupon' as any, { params: data });

// 差价支付
export const getDiffPrice = (data: any) =>
  httpRequest('POST:/api/public/difference_price', { data }, { success: false, fail: false });

// 购买 vip 创建订单
export const vipCreateOrder = (data: any) => httpRequest('POST:/api/customer/vip_create', { data });

// 获取支付方式列表
export const fetchPaymentMethodsList = (params?: {
  billing_address_country_id?: string;
  shipping_address_country_id?: string;
  currency?: string;
  payable?: number;
  base_payable?: number;
}) => httpRequest('GET:/api/pay_center/payment_methods', { params });

export const fetchSmallLanguagePaymentMethods = (params?: {
  billing_address_country_id?: string;
  shipping_address_country_id?: string;
  currency?: string;
  payable?: number;
  base_payable?: number;
}) => httpRequest('GET:/api/pay_center/payment_methods' as any, { params });

// 获取 BNPL 展示产品列表
export const fetchBnplDisplayProducts = (params: {
  scene: 'checkout' | 'product_detail' | 'carts';
  country_id: string;
  currency: string;
  amount?: number;
}) => httpRequest('GET:/api/payment/products' as any, { params }, { success: false, fail: false });

// 退出支付页挽留弹窗
export const getPayPopData = (params: {
  is_have_coupon?: number;
  cart_ids?: number[];
  currency?: string;
}) => httpRequest('GET:/api/order/pay_pop' as any, { params });
